// extracted by mini-css-extract-plugin
module.exports = {"submittedContainer":"Feedback_submittedContainer__5bbZa","submittedContent":"Feedback_submittedContent__xjgPx","csLink":"Feedback_csLink__VDT46"};